import { Record } from 'immutable';

export default class ItemsRecord extends Record({
  id: undefined,
  createdAt: undefined,
  createdBy: undefined,
  items: undefined,
  links: undefined,
}) {
}
